/* __next_internal_client_entry_do_not_use__ IntermediateCheckmark auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { createSVGIcon } from "./util";
/**
 * @trackcomponent
 */ export var IntermediateCheckmark = createSVGIcon(/*#__PURE__*/ _jsx("path", {
    d: "M4.57129 8L11.4284 8",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), "IntermediateCheckmark", {
    viewBox: "0 0 16 16",
    titleAccess: "IntermediateCheckmark",
    strokeWidth: 1.5
});
